<nx-modal *ngIf="firstlogin || forcechangepwd" [hideOnClickOutside]="false" [hideOnEsc]="false" [showCloseIcon]="false"
    windowSize="fixed">
    <div nxLayout='grid'>
        <form [formGroup]="changepassform">
            <div nxRow nxRowJustify="start,around">
                <div nxCol="6" colOffset="3">
                    <h3 class="txtalign_center" nxHeadline="subsection-small">Change password</h3>
                </div>
            </div>
            <div nxRow nxRowJustify="start,around">
                <div nxCol="6" colOffset="4" class="changepass nx-margin-top-2xs">
                </div>
            </div>
            <div nxRow>
                <div nxCol="12">
                    <nx-formfield label="Current Password">
                        <input required nxInput #currentpass type="password" formControlName="currentpass" />
                        <nx-password-toggle [control]="currentpass" ariaLabel="Your custom show password label"
                            nxFormfieldSuffix></nx-password-toggle>
                        <nx-error nxFormfieldError>
                            <b>Please note: </b> you have to fill in your password to continue.
                        </nx-error>
                        <span nxFormfieldSuffix aria-hidden="true" class="nx-margin-left-s"
                            [nxPopoverTriggerFor]="popoverpassinfo" nxPopoverTrigger="hover">
                            <nx-icon name="info-circle-o" size="s"></nx-icon>
                        </span>
                    </nx-formfield>
                </div>
            </div>
            <div nxRow>
                <div nxCol="12">
                    <nx-formfield label="New Password">
                        <input required nxInput #newpass type="password" formControlName="newpass" />
                        <nx-password-toggle [control]="newpass" ariaLabel="Your custom show password label"
                            nxFormfieldSuffix></nx-password-toggle>
                        <nx-error nxFormfieldError>
                            <div *ngIf="f.newpass.errors?.pattern"><strong>Please note: </strong>Should have 1
                                Upper,Lower,Numeric,Special characters</div>
                            <div *ngIf="f.newpass.errors?.required"><strong>Please note: </strong>you have to fill in
                                your password to continue.</div>
                        </nx-error>
                    </nx-formfield>
                </div>
            </div>
            <div nxRow>
                <div nxCol="12">
                    <nx-formfield label="Confirm New Password">
                        <input required nxInput #confirmpass type="password" formControlName="confirmpass" />
                        <nx-password-toggle [control]="confirmpass" ariaLabel="Your custom show password label"
                            nxFormfieldSuffix></nx-password-toggle>
                        <nx-error nxFormfieldError>
                            <div *ngIf="f.confirmpass.errors?.required"><b>Please note: </b> you have to fill in
                                your password to continue.</div>
                            <div *ngIf="f.confirmpass.errors?.mustMatch"><b>Please note: </b> New password must match
                                Confirmed New password.</div>
                        </nx-error>
                    </nx-formfield>
                </div>
            </div>

            <div nxRow class="nx-margin-top-xs" nxRowJustify="start,around">
                <ng-container *ngIf="forcechangepwd">
                    <div nxCol="6">
                        <button (click)="changepassword()" [disabled]='changepassform.invalid' nxButton="block primary">
                            submit
                        </button>
                    </div>
                    <div nxCol="6">
                        <button routerLink='/dashboard' nxButton="block secondary">
                            close
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="firstlogin">
                    <div nxCol="6" colOffset="3">
                        <button (click)="changepassword()" [disabled]='changepassform.invalid' nxButton="block primary">
                            submit
                        </button>
                    </div>
                </ng-container>
            </div>
        </form>
    </div>
</nx-modal>

<nx-popover #popoverpassinfo>
    <div class="mxW200">
        Enter your current password!
    </div>
</nx-popover>